<script setup lang="ts">
import LogoCarousel from './LogoCarousel.vue'
import { useModalStore } from '@/stores/ModalStore'
import LogoSearchModal from './LogoSearchModal.vue'
import Section from '../Section.vue'
import { SectionSettings, Image, Alignment } from '@/components/customer_page/sections/types'
import { computed } from 'vue'
import { getColorById } from '../utils'

interface Props {
  content?: Image[]
  editable?: boolean
  settings: SectionSettings
}

const props = withDefaults(defineProps<Props>(), {
  content: () => [],
  editable: false,
  settings: () => ({
    design_settings: {
      colors: [],
      fonts: [],
    },
  }),
})

const actualSettings = computed(() => ({
  alignment: 'center' as Alignment,
  title: 'Trusted by high-growth companies',
  show_title: true,
  ...props.settings,
}))

const logos = computed(() => (props.content || []).map((logo: Image) => logo.blob_url))
const backgroundColor = computed(() =>
  getColorById(props.settings.design_settings?.colors, 'background_color'),
)

const modalStore = useModalStore()

const openLogoSearchModal = (): void => {
  modalStore.open('logo_search_modal', { title: 'Logo Library' })
}

const emit = defineEmits<{
  (e: 'logoRemoved', logo: string, index: number): void
}>()

const removeLogo = (logo: string, index: number): void => {
  emit('logoRemoved', logo, index)
}
</script>

<template>
  <Section :settings="actualSettings">
    <div class="logos-section">
      <UeTypography v-if="editable && logos.length === 0" :contrast-with-color="backgroundColor">
        No logos added yet.
      </UeTypography>
      <LogoCarousel
        :logos="logos"
        :editable="editable"
        @logoRemoved="removeLogo"
        :showControls="editable"
      />
      <div v-if="editable" class="mt-4 text-center">
        <button class="btn fs-sm btn-secondary font-weight-bold" @click="openLogoSearchModal">
          Browse and add logos
        </button>
      </div>
      <LogoSearchModal />
    </div>
  </Section>
</template>

<style scoped lang="sass">
.logos-section
  margin-top: 2rem
</style>
